export enum AdvisorType {
    ProductFinder = "product-finder",
    ProductCheck = "product-check"
}
